module.exports = __webpack_public_path__ + "static/media/upperDirection.fe3c5cb8.svg";